var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Switch as MuiSwitch } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import Text from '../Text';
import colors from '../../themes/colors';
// Reference: https://mui.com/material-ui/react-switch/#customization
var IOSSwitch = muiStyled(function (props) {
    var onChange = props.onChange, otherProps = __rest(props, ["onChange"]);
    var handleChange = function (event) {
        if (onChange) {
            onChange(event.target.checked);
        }
    };
    return _jsx(MuiSwitch, __assign({ focusVisibleClassName: ".Mui-focusVisible", disableRipple: true }, otherProps, { onChange: handleChange }));
})(function (_a) {
    var theme = _a.theme;
    return ({
        // TODO: Refactor
        '&': {
            padding: 0,
            margin: 0
        },
        '& .MuiSwitch-switchBase': {
            margin: 4,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: colors.neutral80,
                    opacity: 1,
                    border: 0
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5
                }
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#fff',
                border: '6px solid #fff'
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: theme.palette.grey[100]
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.7
            }
        },
        '& .MuiSwitch-track': {
            borderRadius: 20,
            backgroundColor: '#E9E9EA',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500
            })
        },
        '&.MuiSwitch-sizeSmall': {
            '& .MuiSwitch-thumb': {
                boxSizing: 'border-box',
                width: 16,
                height: 16
            },
            '& .MuiSwitch-switchBase': {
                padding: 0
            }
        },
        '&.MuiSwitch-sizeMedium': {
            width: 44,
            height: 28,
            '& .MuiSwitch-switchBase': {
                padding: 0,
                width: 20,
                height: 20
            },
            '& .MuiSwitch-thumb': {
                boxSizing: 'border-box',
                width: 20,
                height: 20
            }
        }
    });
});
var PositionWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  flex-direction: ", ";\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  flex-direction: ", ";\n"])), function (_a) {
    var position = _a.position;
    return (position === 'left' ? 'row' : 'row-reverse');
});
var LabelWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: 1;\n  & > p + p {\n    margin-top: 8px;\n  }\n"], ["\n  flex: 1;\n  & > p + p {\n    margin-top: 8px;\n  }\n"])));
var Switch = function (props) {
    var label = props.label, checked = props.checked, disabled = props.disabled, subLabel = props.subLabel, _a = props.position, position = _a === void 0 ? 'left' : _a, _b = props.size, size = _b === void 0 ? 'medium' : _b, onChange = props.onChange;
    return (_jsxs(PositionWrapper, __assign({ position: position }, { children: [_jsx(IOSSwitch, { size: size, checked: checked, disabled: disabled, onChange: onChange, sx: { margin: 1 } }), _jsxs(LabelWrapper, { children: [label && typeof label === 'string' ? _jsx(Text, __assign({ variant: "body2" }, { children: label })) : label, subLabel &&
                        (typeof subLabel === 'string' ? (_jsx(Text, __assign({ variant: "body2", color: "neutral60" }, { children: subLabel }))) : (subLabel))] })] })));
};
export default Switch;
var templateObject_1, templateObject_2;
